import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Button, Modal, Space, Typography } from 'antd';
import {
  updateCurrentUser,
  updateIsLoggedIn,
  updatePlan,
  updatePlanPermissions,
  updateRmDetails,
  updateNavigationTourGuide,
  updateProductList,
  updateExtraParam,
  updateTheme
} from 'store/user';
import handleApiExceptions from 'utils/handleApiExceptions';
import PageLoader from 'components/PageLoader';
import User from 'services/authentication';
import merchantAPI from 'services/merchants';
import trackingService from 'services/trackingService';
import PORTAL_THEME from '../theme';
// import Alert from 'components/Alert';

const ModalWrapper = styled(Modal)`
  .ant-modal-close {
    top: 10px;
    right: 10px;
  }
  .ant-modal-close-x {
    font-size: 16px;
  }
`;

function RequireAuth() {
  // state to store whether the auth check has completed.
  // const [loading, setLoading] = useState(true);
  const [userConsentModal, setUserConsentModal] = useState(false);
  // state to store whether the user is authenticated
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);

  const user = useSelector((state) => state.user.currentUser);
  const configs = useSelector((state) => state.user.currentUser.configuration);
  const permissions = useSelector((state) => state.user.planPermissions);

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const fetchUserInfo = () => {
    User.info()
      .then((response) => {
        if (response.success) {
          dispatch(updateIsLoggedIn(true));
          dispatch(updateCurrentUser(response.data));
          dispatch(updatePlan(response.data.configuration.plan_configs));
          dispatch(updateExtraParam(response.data.configuration.extra_param));
          dispatch(updateTheme(PORTAL_THEME[response?.data?.merchant_id] || PORTAL_THEME.default));
          dispatch(updatePlanPermissions(response.data.configuration.permission_configs));
          dispatch(updateProductList(response.data.active_product_list));
          setUserConsentModal(response.data.is_consent);
          trackingService.identifyUser(response.data?._id); // eslint-disable-line no-underscore-dangle
        } else {
          handleApiExceptions(response);
        }
      })
      .catch((error) => {
        handleApiExceptions({
          success: false,
          status: (error.response && error.response.status) || 400
        });
      });
  };

  const updateConsent = async () => {
    const response = await merchantAPI.updateConsent();

    if (!response.success) {
      console.log('something went wrong');
      // Alert('something went wrong', 'Please contact support team for this', 'error');
    }
  };

  const handleUserConsentModal = (e) => {
    setUserConsentModal(e);
  };

  const handleAgree = () => {
    handleUserConsentModal(false);
    updateConsent();
  };

  useEffect(() => {
    fetchUserInfo();
  }, []);

  useEffect(() => {
    handleUserConsentModal(true);
  }, [user]);
  useEffect(() => {
    if (isLoggedIn) {
      if (permissions !== undefined) {
        if (
          location.pathname === '/' &&
          Object.prototype.hasOwnProperty.call(permissions, 'can_view_dashboard') &&
          permissions?.can_view_dashboard === true
        ) {
          navigate('/dashboard');
        }
      } else if (location.pathname === '/') {
        navigate('/referrals');
      }
    }
  }, [configs, permissions]);

  const fetchRmDetails = async () => {
    const response = await merchantAPI.fetchRmMappingDetails();
    if (response.success) {
      dispatch(updateRmDetails(response?.data));
    } else {
      console.log('something went wrong');
    }
  };
  const TransctionSummary = async () => {
    await merchantAPI.TransctionSummary();
  };

  const fetchNavigation = async () => {
    const response = await merchantAPI.fetchNavigationFlag();
    if (response.success) {
      dispatch(updateNavigationTourGuide(response?.data));
    } else {
      console.log('something went wrong');
    }
  };

  useEffect(() => {
    if (isLoggedIn && configs && permissions) {
      fetchRmDetails();
      fetchNavigation();
      TransctionSummary();
    }
  }, [isLoggedIn, configs, permissions]);

  useEffect(() => {
    if (isLoggedIn) {
      if (permissions !== undefined) {
        if (
          location.pathname === '/' &&
          Object.prototype.hasOwnProperty.call(permissions, 'can_view_dashboard') &&
          permissions?.can_view_dashboard === false
        ) {
          navigate('/referrals');
        }
        if (
          location.pathname === '/dashboard' &&
          Object.prototype.hasOwnProperty.call(permissions, 'can_view_dashboard') &&
          permissions?.can_view_dashboard === false
        ) {
          navigate('/referrals');
        }
        if (
          location.pathname === '/transactions' &&
          Object.prototype.hasOwnProperty.call(permissions, 'can_view_transactions') &&
          permissions?.can_view_transactions === false
        ) {
          navigate('/referrals');
        }

        if (
          (location.pathname === '/leads' ||
            location.pathname === '/leads/create' ||
            location.pathname === '/leads/update') &&
          Object.prototype.hasOwnProperty.call(permissions, 'can_view_leads') &&
          permissions?.can_view_leads === false
        ) {
          navigate('/referrals');
        }

        if (
          location.pathname === '/invoices' &&
          Object.prototype.hasOwnProperty.call(permissions, 'can_view_invoices') &&
          permissions?.can_view_invoices === false
        ) {
          navigate('/referrals');
        }

        if (
          location.pathname === '/payout-reports' &&
          Object.prototype.hasOwnProperty.call(permissions, 'can_view_payout_report') &&
          permissions?.can_view_payout_report === false
        ) {
          navigate('/referrals');
        }

        if (
          location.pathname === '/custom-reports' &&
          Object.prototype.hasOwnProperty.call(permissions, 'can_view_custom_report') &&
          permissions?.can_view_custom_report === false
        ) {
          navigate('/referrals');
        }
      }
    }
  }, [configs, permissions]);

  if (isLoggedIn) {
    // if (
    //   configs !== undefined &&
    //   !configs.permission_configs.can_view_referrals &&
    //   !configs.permission_configs.can_view_leads &&
    //   !configs.permission_configs.can_view_invoices &&
    //   !configs.permission_configs.can_view_payout_report &&
    //   !configs.permission_configs.can_view_custom_report &&
    //   !configs.permission_configs.can_view_settings
    // ) {
    //   Alert('Alert!', `${error.response.data.message}`, 'warning', {
    //     okText: 'Go to Easebuzz',
    //     onOk: () => {
    //       window.location.replace(`${process.env.REACT_APP_DASHBOARD_URL}`);
    //     }
    //   });
    //   setTimeout(() => {
    //     window.location.replace(`${process.env.REACT_APP_DASHBOARD_URL}`);
    //   }, 5000);

    //   return null;
    // }

    // This is the view if the user was authenticated.
    if (user !== undefined && user.is_consent === false) {
      return (
        <>
          <ModalWrapper
            title={
              <Typography.Text
                style={{
                  fontSize: '20px',
                  fontWeight: '500',
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  padding: '10px',
                  borderBottom: '1px solid #A0A0A0'
                }}
              >
                User Consent - Partner&apos;s Terms of Use
              </Typography.Text>
            }
            centered
            open={userConsentModal}
            closable={false}
            footer={[
              <Space style={{ width: '100%', justifyContent: 'center' }} key="consent_action">
                <Button type="primary" onClick={handleAgree} size="large">
                  I Agree
                </Button>
              </Space>
            ]}
          >
            <Space
              style={{
                padding: '25px',
                textAlign: 'center'
              }}
            >
              <Typography.Text
                style={{
                  fontSize: '16px',
                  width: '100%'
                }}
              >
                By accessing this Partner&apos;s application and services, I agree to the{' '}
                <a
                  href={`${process.env.REACT_APP_EBZ_URL}terms/partner`}
                  style={{ textDecoration: 'underline' }}
                  target="_blank"
                  rel="noreferrer"
                >
                  Partner&apos;s Terms of Use.
                </a>
              </Typography.Text>
            </Space>
          </ModalWrapper>
          <Outlet />
        </>
      );
    }
    return <Outlet />;
  }

  // This is the view if the user was not authenticated
  // most likely not be displayed for any significant (or even preceivable)
  // amount of time.
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'start',
        alignItems: 'center',
        width: '100vw',
        height: '100vh'
      }}
    >
      <PageLoader />
    </div>
  );
}

export default RequireAuth;
